import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=93cc238e&scoped=true&"
import script from "./Newsletter.vue?vue&type=script&lang=ts&"
export * from "./Newsletter.vue?vue&type=script&lang=ts&"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=93cc238e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cc238e",
  null
  
)

export default component.exports